// extracted by mini-css-extract-plugin
export var bodySections = "_9c-8";
export var gray = "_9c-7";
export var green = "_9c-4";
export var iconContainer = "_9c-9";
export var iconWidgetContainer = "_9c-1";
export var phoneIcon = "_9c-2";
export var red = "_9c-5";
export var statusDot = "_9c-3";
export var widgetContainer = "_9c-0";
export var yellow = "_9c-6";